import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center anim-fade-up">
        <p className="font-mono text-[11px] uppercase tracking-[0.08em] text-[var(--color-slate-300)]">
          404
        </p>
        <h1 className="mt-3 text-heading-lg font-semibold text-[var(--color-snow)]">
          Lost in the void.
        </h1>
        <p className="mt-3 text-[14px] text-[var(--color-slate-200)] max-w-sm mx-auto">
          That page doesn't exist on platform.eon.health.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block text-[13px] text-[var(--color-snow)] hover:text-[var(--color-sky)] transition-colors"
        >
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
